module["exports"] = [
  "#{prefix} #{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{last_name} #{first_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr/name/name.js
 ** module id = 592
 ** module chunks = 0
 **/